<template>
  <form>
    <step-one
      v-show="step === 1"
      @nextStep="getStep"
      @cancel="handleCancel"
      @dataForm="getFormPart"
    ></step-one>
    <step-two
      v-show="step === 2"
      @finalStep="getStep"
      :form-data="this.form"
      @afterSubmitForm="handleAfterSubmitForm"
    ></step-two>
  </form>
</template>
<script>
import stepOne from './stepOne'
import stepTwo from './stepTwo'
export default {
  components: {
    stepOne,
    stepTwo
  },
  data () {
    return {
      steps: 2,
      step: 1,
      form: {}
    }
  },
  mounted () {
    this.$emit('stepNumber', this.step)
  },
  methods: {
    getStep (step) {
      this.step = step
      this.$emit('stepNumber', this.step)
    },
    getFormPart (form) {
      this.form = form
    },
    handleAfterSubmitForm (id) {
      this.$emit('afterSubmitForm', id)
    },
    handleCancel () {
      this.$emit('cancel')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/creationProjectModal/index.vue